import React, { useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Link, useNavigate } from "react-router-dom";
import { format, subDays } from "date-fns";
import { Calendar } from "primereact/calendar";
import storage from "../../Services/Storage";
import Axios from "../../api/Axios";
import Loader from "../../../src/Components/Loader";

const FocUnlockRequestAll = () => {
    const auth = storage.getLocal("user");
    const date = subDays(new Date(), 7);
    const [fromDate, setFromDate] = useState(date);
    const [getQrmdatatbl, setGetQrmdatatbl] = useState([]);
    const [toDate, setToDate] = useState(new Date());
    const [loadingExcel, setLoadingExcel] = useState(false);

    let nav = useNavigate();

    const getData = async()=>{
        const fDate = new Date(fromDate);
        const fromDateRange = format(fDate, "dd/MM/yyyy");
        const tDate = new Date(toDate);
        const toDateRange = format(tDate, "dd/MM/yyyy");
        try {
            setLoadingExcel(true);
            const cnFocQrmurl = "QRM_CN/GetCNRrecords?";
            const cnFocQrmData = `${cnFocQrmurl}strEmpId=${auth.UserId}&strFromDate=${fromDateRange}&strToDate=${toDateRange}&Tag=N`;
            let dataresponse = await Axios.get(cnFocQrmData);
            setGetQrmdatatbl(dataresponse.data.Data);
        } catch (error) {
            console.log(error);
        } finally {
            setLoadingExcel(false);
        }
    };

    useEffect(()=>{
        getData();
    },[]);

    const toViewQRM = (rowdata) => {
        return (
            <div className="action-icon">
                <button
                    className="grid-icon-img"
                    title="View QRM Details"
                    onClick={() => {
                        nav(`/qrm/FocUnlockRequestAddNew?qrmHdrId=${rowdata.QRM_H_ID}`);
                    }}
                >
                    <img alt='InnoRise' src={require("../../Assets/Images/ViewEdit.png")} />
                </button>
            </div>
        );
    };

    return (
        <>
            <div className="col-12 pt-3 pb-3">
                <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-12">
                        <h3 className="py-2">FOC Unlock Request</h3>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12">
                        <div className="float-end mb-2">
                            <Link to="/qrm/FocUnlockRequestAddNew">
                                <button type="submit" className="btn btn-primary">
                  Add New
                                </button>
                            </Link>
                        </div>
                    </div>
                </div>
                <section className="sales-box">
                    <form>
                        <div className="row d-flex justify-content-end align-items-end">
                            <div className="col-lg-4 col-md-4 col-sm-12">
                                <label className="form-label">From Date</label>
                                <Calendar
                                    onChange={(e) => setFromDate(e.value)}
                                    showIcon
                                    value={fromDate}
                                    min="2010-01-01"
                                    dateFormat="dd/mm/yy"
                                    showMinMaxRange={true}
                                />
                            </div>
                            <div className="col-lg-4 col-md-4 col-sm-12">
                                <label className="form-label">To Date</label>
                                <Calendar
                                    value={toDate}
                                    onChange={(e) => setToDate(e.value)}
                                    showIcon
                                    min="2010-01-01"
                                    dateFormat="dd/mm/yy"
                                    showMinMaxRange={true}
                                />
                            </div>

                            <div className="col-lg-4 col-md-4 col-sm-12">
                                <div className="text-end">
                                    <button
                                        type="button"
                                        title="Get Data"
                                        className="btn btn-primary"
                                        onClick={getData}
                                    >
                        Get Data
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </section>
                <section className="mb-3">
                    {loadingExcel?<><Loader/></>:<div className="col-lg-12 col-md-12 col-sm-12">
                        <h3 className="py-2">Records</h3>
                        <div className="col-lg-12 col-md-12 col-sm-12">
                            <div className="DataTable">
                                <DataTable
                                    value={getQrmdatatbl}
                                    rows={10}
                                    filterDisplay="row"
                                    paginator
                                    // showGridlines
                                    stripedRows
                                    selectionMode="checkbox"
                                    scrollHeight="80vh"
                                    scrollable
                                >
                                    <Column
                                        field="QRM_H_ID"
                                        header="QRM No."
                                        filter
                                        filterMatchMode="contains"
                                        filterPlaceholder="Search Here..."
                                    ></Column>
                                    <Column field="REQ_DATE" header="Date"></Column>
                                    <Column
                                        field="QRM_STATUS"
                                        header="Status"
                                        filter
                                        filterMatchMode="contains"
                                        filterPlaceholder="Search Here..."
                                    ></Column>
                                    <Column body={toViewQRM} header="View Details"></Column>
                                </DataTable>
                            </div>
                        </div>
                    </div>}
                </section>
            </div>
        </>
    );
};

export default FocUnlockRequestAll;
